import { HTMLAttributes } from 'react';

import { LoadingCard } from '@britishcouncil/react-solas-ors3';

import styled from '@emotion/styled';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  text?: string;
}

export const FullScreenLoadingBox = ({ title, text, ...divProps }: Props) => (
  <StyledBox {...divProps}>
    <LoadingCard title={title}>{text || 'One second, please'}</LoadingCard>
  </StyledBox>
);

const StyledBox = styled.div`
  height: 100%;
  display: flex;
  z-index: 1;
  align-items: center;
  justify-content: center;
  & > div {
    width: 100%;
  }
`;
